import FormLabel from './formLabel-TEMPLATE_VERSION'

export default FormLabel
